import { get_el } from 'js/utils';
import MB_Filter_Buttons from './filter_buttons';
import MB_Filter_Dropdowns from './filter_dropdowns';

export default class MB_Filters {

    constructor(mb){
        this.mb = mb;
        this.mb.hooks.after_filter = [];
        this.container = get_el(mb.settings.filters_container) || mb.container;
        this.filters = {};

        new MB_Filter_Buttons(this);
        new MB_Filter_Dropdowns(this);
    }

    apply(){
        this.mb.filter();
        // this.isotope_filter();
        // this.mb.toggle_no_results();
        // this.mb.show_minimum_items();
        this.mb.hooks.after_filter.forEach(action=>action());
    }
    
    register_field(container){

        const key = container.dataset.filter_key;
        const is_multiple = typeof container.dataset.filter_multiple !== 'undefined';
        const query_type = container.dataset.query_type ?? 'tax_query';

        this.filters[key] = {
            value: is_multiple ? [] : '',
            query_type,
            key,
        };
    }

    set_value(key, value){
        this.filters[key].value = value;
    }

    add_value(key, value){
        let filter_value = this.filters[key].value;
        if( filter_value.indexOf(value) !== -1 ) return;
        filter_value.push(value); 
    }

    remove_value(key, value){
        let filter_value = this.filters[key].value;
        if( filter_value.indexOf(value) === -1 ) return;
        filter_value.splice(filter_value.indexOf(value), 1);
    }
    
    // isotope_filter(){
    //     const filter = this.get_isotope_filter_string();
    //     this.mb.isotope.arrange({ filter });
    // }
    
    // get_isotope_filter_string(){

    //     let filter_string = '';
    //     let exclusives = '';
    //     const inclusives = [];
        
    //     for( let key in this.filters ) {
    //         const value = this.filters[key].value;
    //         if( Array.isArray(value) ) {
    //             if( !value.length ) continue;
    //             value.forEach(value=>{
    //                 inclusives.push('[data-'+ key +'*="'+ value +'"]');
    //             })
    //         }
    //         else {
    //             if( !value ) continue;
    //             exclusives += '[data-'+ key +'*="'+ value +'"]';
    //         }
    //     }
        
    //     if( inclusives.length ) {
    //         filter_string = inclusives.map(inclusive=>{
    //             return exclusives + inclusive;
    //         }).join(',');
    //     }
    //     else {
    //         filter_string = exclusives;
    //     }

    //     return filter_string;
    // }

    have_filters(){
        for( let key in this.filters ) {
            const value = this.filters[key].value;
            if( Array.isArray(value) ) {
                if( value.length ) return true;
            }
            else {
                if( value ) return true;
            }
        }
        return false;
    }

    filter_item(el){
        
        for( let key in this.filters ) {

            let value = this.filters[key].value;

            const dataset_key = this.get_dataset_key(key);

            if( Array.isArray(value) ) {
                if( !value.length ) continue;
                for( const v of value ) {
                    if( el.dataset[dataset_key].indexOf(v) === -1 ) {
                        return false;
                    }
                }
            }
            else {
                if( !value ) continue;
                if( el.dataset[dataset_key].indexOf(value) === -1 ) {
                    return false;
                }
            }
        }

        return true;
    }

    get_dataset_key(key){

        if( key.includes('-') ) {
            return key.replace(/-([a-z])/g, function(g){
                return g[1].toUpperCase();
            });
        }

        return key;
    }

}